import { IRootState } from '../../types/redux/root';

export const tableStateSelector = (tableName?: string) => (root: IRootState) => (typeof tableName === 'string' ? root.tables[tableName] : undefined);

export const selectedRowsSelector = (tableName: string) => (root: IRootState) => root.tables[tableName]?.selectedRows;
